import { render } from "./AddMpostBoxPage.vue?vue&type=template&id=03e55bc6&ts=true"
import script from "./AddMpostBoxPage.vue?vue&type=script&lang=ts"
export * from "./AddMpostBoxPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__